import { webDataNotAsked } from '@cobliteam/api-lib';
import { Location, UserRole } from '@cobliteam/common-types';
import { DatadogTrack } from '@cobliteam/datadog-rum';
import { useTitle } from '@cobliteam/hooks';
import { type AppState, history, loginResetState, selectLocationPathname } from '@cobliteam/store';
import { Loading } from '@cobliteam/ui/components';
import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { Suspense, useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ReactComponent as CobliLogo } from '../../assets/cobli-logo.svg';
import LoginMKT from '../../components/LoginMKT';
import * as styles from './styles';

const AuthLayout = ({ children }: any) => {
  useTitle('Login');
  const dispatch = useDispatch();
  const session = useSelector((state: AppState) => state.login.session);
  const pathname = useSelector((state: AppState) => selectLocationPathname(state));
  const isHome = useMemo(() => pathname === Location.LOGIN, [pathname]);

  if (session) {
    return session.user.role !== UserRole.MAP_VIEW ? <Redirect to={Location.HOME} /> : <Redirect to={Location.MONITORING} />;
  }

  const handleGoBack = () => {
    if (pathname === Location.TOKEN_VALIDATION) {
      dispatch(
        loginResetState({
          forgetPasswordWebData: webDataNotAsked(),
          validateTokenWebData: webDataNotAsked(),
          token: '',
        })
      );
    }

    history.goBack();
  };

  return (
    <div className='grid h-screen grid-cols-12 gap-4 bg-[#18182e]'>
      <section className='col-span-12 mobile:col-span-12 tablet:col-span-6'>
        <div className={styles.login}>
          <CobliLogo className='h-32 text-white' />

          <div className={styles.previousStep}>
            {isHome ? null : (
              <Button variant='ghost' startIcon={<Icon name='arrow-left' />} onClick={handleGoBack}>
                Voltar
              </Button>
            )}
          </div>

          <div className='p-6'>
            <Suspense fallback={<Loading />}>{children}</Suspense>
          </div>
        </div>
      </section>
      <section className='col-span-12 mobile:col-span-12 tablet:col-span-6 tablet:grid hidden'>
        <ErrorBoundary
          onError={(error, errorInfo) => {
            DatadogTrack.error(error, {
              component: 'AuthLayout',
              errorInfo,
            });
          }}
          fallbackRender={() => <div className='flex h-full items-center justify-center'>Erro ao carregar a página</div>}
        >
          <LoginMKT />
        </ErrorBoundary>
      </section>
    </div>
  );
};

export default AuthLayout;
